// app/api/skunkworks.ts
export async function generateTokenForStore(store: string): Promise<string> {
    const response = await fetch("/api/skunkworks", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ store }),
    });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to generate token: ${errorText}`);
    }
    const data = await response.json();
    return data.token;
}